import { render, staticRenderFns } from "./WithdrawalModal.vue?vue&type=template&id=db63946c&"
import script from "./WithdrawalModal.vue?vue&type=script&lang=js&"
export * from "./WithdrawalModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports